/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import {ApplyJsonConfigurationController, ViewJsonConfigurationController} from './json-configuration.controller';
import JsonConfigurationStatusTableConfig from './json-configuration-status-table.config';

export default angular.module('tektelic.jsonConfiguration', [])
    .factory('jsonConfigurationStatusTableConfig', JsonConfigurationStatusTableConfig)
    .controller('ApplyJsonConfigurationController', ApplyJsonConfigurationController)
    .controller('ViewJsonConfigurationController', ViewJsonConfigurationController)
    .name;



// WEBPACK FOOTER //
// ./src/app/json-configuration/index.js